import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import React from 'react'
import { NavLink } from 'react-router-dom'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './SettingsNavigation.module.sass'
import { rulesNavigation } from 'controllers/App/navigation'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

const createNavLink = (to, exact, icon, name) => {
	return (
		<NavLink
			key={to}
			to={to}
			exact={exact}
			className={styles['settings-entry']}
			activeClassName={styles['--is-selected']}
		>
			{icon && <Icon name={icon} width='16px' height='16px' />}
			<h5 className={styles['title']}>{name}</h5>
			<Icon name='chevron' width='16px' height='16px' />
		</NavLink>
	)
}

const SettingsNavigation = () => {
	const { i18n } = useGlobal()
	const { priority, eventsSubscriptions } = rulesNavigation(i18n)

	return (
		<VStack gap='xsmall'>
			<HStack justify='center'>
				<button className={styles['new-settings-button']}>
					<a href='/v2' target='_blank' rel='noopener noreferrer'>
						{i18n`Allocation rules`}
					</a>
				</button>
			</HStack>
			<ExpandableWidget
				className={styles['section-title']}
				heading='h5'
				title={i18n`Priority rules`}
			>
				<VStack>
					{priority.map(({ to, exact, icon, name }) =>
						createNavLink(to, exact, icon, name)
					)}
				</VStack>
			</ExpandableWidget>
			<ExpandableWidget
				className={styles['section-title']}
				heading='h5'
				title={i18n`Events subscriptions`}
			>
				<VStack>
					{eventsSubscriptions.map(({ to, exact, name }) =>
						createNavLink(to, exact, '', name)
					)}
				</VStack>
			</ExpandableWidget>
		</VStack>
	)
}

export default SettingsNavigation
